import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TransferDataPage } from './transfer-data';

@NgModule({
  declarations: [
    TransferDataPage,
  ],
  imports: [
    IonicPageModule.forChild(TransferDataPage),
  ],
})
export class TransferDataPageModule {}



// WEBPACK FOOTER //
// ./src/pages/transfer-data/transfer-data.module.ts